import { render, staticRenderFns } from "./alertProposal.vue?vue&type=template&id=dc407106&scoped=true&"
import script from "./alertProposal.vue?vue&type=script&lang=js&"
export * from "./alertProposal.vue?vue&type=script&lang=js&"
import style0 from "./alertProposal.vue?vue&type=style&index=0&id=dc407106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc407106",
  null
  
)

export default component.exports